<div class="p-fluid p-grid">
  <div class="order-form-container">
    <form novalidate #formRef1="ngForm" (ngSubmit)="onSubmit(formRef1)">
      <div class="border-panel">
        <p class="centered-border1">New Address</p>
        <div style="display: flex; flex-direction: column;">
          <div style="display: flex; padding-left: 2% ">

            <div
              style="display: flex;flex-direction: column;padding-right: 45px; border-right: 2px solid inherit;">

              <div class="orderentryaddressdiv" style="margin-bottom: 10px;">
                <div class="col-sm-5 form-group">
                  <label class="font-label-text required-label">House Number: *</label>
                  <app-textinput [(ngModel)]="newHouseNumber" name="newHouseNumber"
                    (valueChange)="onNewHouseNoChange($event)" [maxlength]="10" [required]="true"
                  [placeholder]="'House Number'" #newHouseNoRef="ngModel"></app-textinput>
                  @if (newHouseNoRef.invalid && newHouseNoRef.touched) {
                    <div
                      class="text-danger Validation">
                      Enter House Number.
                    </div>
                  }
                </div>
                <div class="col-sm-5 form-group">
                  <label class="font-label-text required-label">Street: *</label>
                  <app-textinput [(ngModel)]="newStreet" name="newStreet"
                    (valueChange)="onNewStreetChange($event)" [required]="true"
                    [placeholder]="'Street'" #newStreetRef="ngModel"
                  [maxlength]="20"></app-textinput>
                  @if (newStreetRef.invalid && newStreetRef.touched) {
                    <div
                      class="text-danger Validation">
                      Enter Street Address.
                    </div>
                  }
                </div>
              </div>

              <div class="orderentryaddressdiv" style="margin-bottom: 10px;">
                @if (isNewCityText) {
                  <div class="col-sm-4 form-group">
                    <label class="font-label-text required-label">City: *</label>
                    <app-textinput [(ngModel)]="newCityValue" name="newCityValue"
                      (valueChange)="onNewCityTextChange($event)" [required]="true"
                    [placeholder]="'City'" #newCityRef="ngModel"></app-textinput>
                    @if (newCityRef.invalid && newCityRef.touched) {
                      <div
                        class="text-danger Validation">
                        Enter City Name.
                      </div>
                    }
                  </div>
                }
                @if (!isNewCityText) {
                  <div class="col-sm-5 form-group" [ngClass]="{'disabled-class': isNewCity}"
                    >
                    <label class="font-label-text required-label">City: *</label>
                    <app-dropdown [options]="CityDropdownOptions" [(selectedValue)]="newCityValue"
                      (selectedValueChange)="OnNewCityChanged($event)" placeholder=""
                      class="custom-width font-label-text fixed-width-dropdown" [showLabel]="true"
                      [showFloatingLabel]="false" [required]="true" [validationName]="'City'"
                    [isFormSubmitted]="isFormSubmitted" class="custom-width"></app-dropdown>
                  </div>
                }
                <div class="col-sm-3 form-group dropdown-container">
                  <label class="font-label-text required-label">State: *</label>
                  <app-dropdown [options]="StateDropdownOptions"
                    [(selectedValue)]="newStateSelectedValue"
                    (selectedValueChange)="OnNewStateChanged($event)" placeholder=""
                    class="fixed-width-dropdown custom-width" [showLabel]="true"
                    [showFloatingLabel]="false" [validationName]="'State'"
                  [isFormSubmitted]="isFormSubmitted" [required]="true"></app-dropdown>
                </div>
                <div class="col-sm-3 form-group" style="width: 27%;">
                  <label class="font-label-text">ZIP:</label>
                  <app-textinput [(ngModel)]="newZip" name="newZip"
                    (valueChange)="onNewZipChange($event)" [maxlength]="10" [placeholder]="'Zip'"
                  #newZipRef="ngModel"></app-textinput>
                </div>
              </div>
              <hr style="width: 110%;">
              <div style="margin-top: 4px;margin-bottom: 10px;float:right;width: 110%;">
                <div class="col-sm-12 form-group">
                  <div class="meternumdiv">
                    <label class="font-label-text">Meter Number:</label>
                    <div class="col-sm-6">
                      <app-textinput [(ngModel)]="meterNumber" name="meterNumber"
                        (valueChange)="onMeterNumberChange($event)" [maxlength]="15"
                        [placeholder]="'Meter Number'" #meterNumberRef="ngModel"
                      class="newaddresstxtinput"></app-textinput>
                    </div>
                  </div>
                </div>
                                <div class="col-sm-12 form-group" style="display: flex; justify-content: space-between;
                align-items: center;
                width: 100%;padding-bottom: 10px">
                  <label class="font-label-text">Installation Number:</label>
                  <div class="col-sm-6">
                    <app-textinput [(ngModel)]="installationNumber" name="installationNumber"
                      (valueChange)="onInstallationNumberChange($event)" [maxlength]="15"
                      [placeholder]="'Installation Number'" #installationNumberRef="ngModel"
                    class="newaddresstxtinput"></app-textinput>
                  </div>
                </div>

                                <div class="col-sm-12 form-group" style="display: flex; justify-content: space-between;
                align-items: center;
                width: 100%; padding-bottom: 10px">
                  <label class="font-label-text">Driver License State:</label>
                  <div class="col-sm-6">
                    <app-dropdown [options]="usStates"
                      [(selectedValue)]="driverLicenseState"
                      (selectedValueChange)="onDriverLicenseStateChange($event)" placeholder=""
                      class="fixed-width-dropdown custom-width" [showLabel]="true"
                    [showFloatingLabel]="false"></app-dropdown>
                  </div>
                </div>
                                <div class="col-sm-12 form-group" style="display: flex; justify-content: space-between;
                align-items: center;
                width: 100%;padding-bottom: 10px">
                  <label class="font-label-text">Driver License Number:</label>
                  <div class="col-sm-6">
                    <app-textinput [(value)]="driverLicenseNumber" name="driverLicenseNumber"
                      (valueChange)="onDriverLicenseNumberChange($event)" [maskFormat]="true"
                      maxlength="20" [placeholder]="'Driver License Number'" appMasker
                    class="newaddresstxtinput"></app-textinput>
                  </div>
                </div>
                                <div class="col-sm-12 form-group" style="display: flex;justify-content: space-between;
                                    align-items: center;
                                    width: 100%;">
                  <label class="font-label-text">Marital Status:</label>
                  <div class="col-sm-6">
                    <app-dropdown [options]="maritalStatusOptions" [(selectedValue)]="maritalStatus"
                      (selectedValueChange)="onMaritalStatusChange($event)"
                      placeholder="Select Status" class="fixed-width-dropdown custom-width"
                    [showLabel]="true" [showFloatingLabel]="false"></app-dropdown>
                  </div>
                </div>
              </div>
            </div>



            <div class="col-sm-4 form-group"
              style="display: flex; flex-direction: column; padding: 8px; margin-left: 10px; border-left: 2px solid rgba(75, 85, 99, 0.10)">
              <div class="form-group">
                <label class="font-label-text required-label">Date Service to Begin: *</label>
                <p-datepicker [(ngModel)]="serviceBeginDate" name="serviceBeginDate" [required]="true"
                  class="calender-icon" [showIcon]="true"
                  (onSelect)="onServiceBeginDateChange($event)" dateFormat="mm/dd/yy"
                #serviceBeginDateInput="ngModel"></p-datepicker>
                @if (serviceBeginDateInput.invalid && serviceBeginDateInput.touched) {
                  <div
                    class="text-danger Validation">
                    Select service begin date.
                  </div>
                }
              </div>

            </div>



          </div>


          @if (maritalStatus !== 'SINGLE') {
            <hr style="width: 102%;">
          }
          @if (maritalStatus !== 'SINGLE') {
            <div class="orderentrydiv" style="margin-bottom: 10px; padding: 8px;width: 102%;"
              >
              <div class="col-sm-12" style="display: flex">
                <label class="font-label-text pt-1">Set up Spouse:</label>
                <div class="col-sm-4 gender-options pl-2">
                  <app-radio-button [options]="setSpouseName" name="spouseSetup"
                    [(ngModel)]="setupInSpouseName" (onClick)="onSpouseSetupChange($event)"
                    class="font-label-text">
                  </app-radio-button>
                </div>
                @if (setupInSpouseName === 'Yes') {
                  <div class="col-sm-6 gender-options">
                    <label class="font-label-text">Spouse SSN:</label>
                    <app-textinput [(value)]="spouseSSN" (valueChange)="onSpouseSSNChange($event)"
                      appSsnMasker maxlength="11" [placeholder]="'SSN'"
                    [applySsnMasker]="true"></app-textinput>
                  </div>
                }
              </div>
            </div>
          }

          @if (setupInSpouseName === 'Yes' && maritalStatus !== 'SINGLE') {
            <div class="orderentrydiv">
              <div class="col-sm-4 form-group">
                <label class="font-label-text required-label">Spouse Last Name: *</label>
                <app-textinput [(ngModel)]="spouseLastName" name="spouseLastName"
                  (valueChange)="onSpouseLastNameChange($event)" [maxlength]="20" [required]="true"
                [placeholder]="'Spouse Last Name'" #spouseLastNameRef="ngModel"></app-textinput>
                @if (spouseLastNameRef.invalid && spouseLastNameRef.touched) {
                  <div
                    class="text-danger Validation">
                    Enter Spouse Last Name.
                  </div>
                }
              </div>
              <div class="col-sm-4 form-group">
                <label class="font-label-text required-label">Spouse First Name: *</label>
                <app-textinput [(ngModel)]="spouseFirstName" name="spouseFirstName"
                  (valueChange)="onSpouseFirstNameChange($event)" [maxlength]="20" [required]="true"
                [placeholder]="'Spouse First Name'" #spouseFirstNameRef="ngModel"></app-textinput>
                @if (spouseFirstNameRef.invalid && spouseFirstNameRef.touched) {
                  <div
                    class="text-danger Validation">
                    Enter Spouse First Name.
                  </div>
                }
              </div>
              <div class="col-sm-4 form-group">
                <div class="gender-options pt-4 pl-2">
                  <app-radio-button [options]="setSpouseGender" name="spouseGender"
                    [(ngModel)]="spouseGender" (onClick)="onSpouseGenderChange($event)"
                    class="font-label-text">
                  </app-radio-button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>





      <div class="border-panel">
        <p class="centered-border1">Program Enrollment</p>
        <div style="display: flex;">
          <div style="display: flex; flex-direction: column; padding: 8px;">
            <div class="form-container">
              <div class="grid">
                <div class="col-12">
                  <label class="font-label-text">Check all features for which the customer would like
                  to enroll:</label>
                  <div class="flex flex-row justify-content-between align-items-center mt-2">
                    <div class="flex align-items-center">
                      <p-checkbox [(ngModel)]="automaticBankDraft" [binary]="true"
                        name="automaticBankDraft" inputId="automaticBankDraft"
                      (onChange)="onCheckboxChange($event)"></p-checkbox>
                      <label for="automaticBankDraft" class="ml-2 font-label-text">Automatic Bank
                      Draft</label>
                    </div>
                    <div class="flex align-items-center">
                      <p-checkbox [(ngModel)]="averageMonthlyBilling" [binary]="true"
                        name="averageMonthlyBilling" inputId="averageMonthlyBilling"
                      (onChange)="onCheckboxChange($event)"></p-checkbox>
                      <label for="averageMonthlyBilling" class="ml-2 font-label-text">Average
                      Monthly Billing</label>
                    </div>
                    <div class="flex align-items-center">
                      <p-checkbox [(ngModel)]="elderlyDisabled" [binary]="true"
                        name="elderlyDisabled" inputId="elderlyDisabled"
                      (onChange)="onCheckboxChange($event)"></p-checkbox>
                      <label for="elderlyDisabled"
                      class="ml-2 font-label-text">Elderly/Disabled</label>
                    </div>
                    <div class="flex align-items-center">
                      <p-checkbox [(ngModel)]="budgetPlan" [binary]="true" name="budgetPlan"
                      inputId="budgetPlan" (onChange)="onCheckboxChange($event)"></p-checkbox>
                      <label for="budgetPlan" class="ml-2 font-label-text">Budget Plan</label>
                    </div>
                  </div>
                </div>
                <hr style="width: 100%;">
                <div style=" width: 100%;">
                  <div class="col-12">
                    <div class="flex align-items-center">
                      <label class="mr-4 font-label-text">Bad Debt at Premise?</label>
                      <div class="flex gap-4">
                        <div class="form-group gender-options">
                          <app-radio-button [options]="badDebtTypes" name="badDebt"
                            [(ngModel)]="badDebt" class="font-label-text"
                            (onClick)="onbadDebtChange($event)">
                          </app-radio-button>
                        </div>

                      </div>
                    </div>
                  </div>


                  @if (badDebt === 'Yes') {
                    <div class="col-12 md:col-14 mt-4">
                      <div class="field">
                        <label class="font-label-text">Deposit Required Amount</label>
                        <div>
                          <app-numberinput [(ngModel)]="depositAmount" name="depositAmount"
                            [placeholder]="'Deposit Required Amount'" [mode]="inputNumberMode"
                            [value]="depositAmount"
                            (valueChange)="onDepositAmountChange($event)" [required]="false"
                            #depositAmountRef="ngModel" [maxLength]="10"
                          [maxValue]="9999999.99"></app-numberinput>
                        </div>
                      </div>
                    </div>
                  }
                  <hr style="width: 100%;" />

                  <div class="col-12 mt-1">
                    <div class="field">
                      <label class="font-label-text">Comments</label>
                      <textarea class="form-control custom-textarea font-label-text"
                        #commentsRef="ngModel" [required]="false" name="comments"
                      [(ngModel)]="comments" (change)="onCommentsChange($event)"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>



      </form>
    </div>
  </div>